export default __webpack_public_path__ + "static/irnerio-white-def-5a080d2163dcdeabf38ad652b7bbfcda.png";